define('common/matomoHelper',[
],
    function () {

        function trackFormSubmit(formId) {
            if (window._paq) {
                if (formId.startsWith("#")) formId = formId.substring(1);
                _paq.push(['FormAnalytics::trackFormSubmit', document.getElementById(formId)]);
            }
        }

        function trackFormConversion(formId) {
            if (window._paq) {
                if (formId.startsWith("#")) formId = formId.substring(1);
                _paq.push(['FormAnalytics::trackFormConversion', document.getElementById(formId)]);
            }
        }

        function trackSearchResultsCount(searchParameters, searchCount, searchCategory) {
            if (window._paq) {
                // documentation: https://developer.matomo.org/guides/tracking-javascript-guide#internal-search-tracking
                if (typeof searchCategory === "undefined" || searchCategory === null) searchCategory = false;
                _paq.push(['trackSiteSearch', searchParameters, searchCategory, searchCount]);
            }
        }

        return {
            trackFormSubmit: trackFormSubmit,
            trackFormConversion: trackFormConversion,
            trackSearchResultsCount: trackSearchResultsCount
        };
    });

